(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awards-banner-new"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(root) {
      var grid = root.querySelector('.aww__grid');
      var dots = root.querySelector('.aww__dots');
      if (!grid || !dots || grid.getAttribute('data-aww-ready')) return;
      grid.setAttribute('data-aww-ready', 'true');

      var cells = Array.prototype.slice.call(grid.children);
      var buttons = [];
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function offset() {
        return parseFloat(window.getComputedStyle(grid).paddingLeft) || 0;
      }

      cells.forEach(function (cell, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'aww__dot';
        b.setAttribute('aria-label', 'Go to award ' + (i + 1));
        b.addEventListener('click', function () {
          grid.scrollTo({ left: cell.offsetLeft - offset(), behavior: reduce ? 'auto' : 'smooth' });
        });
        dots.appendChild(b);
        buttons.push(b);
      });

      function update() {
        var pos = grid.scrollLeft + offset();
        var best = 0;
        var bestDist = Infinity;
        cells.forEach(function (cell, i) {
          var d = Math.abs(cell.offsetLeft - pos);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        if (grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4) best = cells.length - 1;
        buttons.forEach(function (b, i) {
          if (i === best) b.setAttribute('aria-current', 'true');
          else b.removeAttribute('aria-current');
        });
      }

      var ticking = false;
      grid.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.aww--slider').forEach(initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
